import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as _ from 'lodash';

@Component({
    selector: 'app-dialog-date-filters',
    templateUrl: './dialog-date-filters.component.html',
    styleUrls: ['./dialog-date-filters.component.scss'],
    standalone: false
})
export class DialogDateFiltersComponent implements OnInit {

    filters = {
        allDays: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
        monday: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
        tuesday: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
        wednesday: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
        thursday: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
        friday: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
        saturday: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
        sunday: {
            from: "00:00",
            to: "24:00",
            checked: true
        },
    };

    specificDaysDisabled: boolean = true;
    specificChecked: boolean = false;

    constructor(public dialogRef: MatDialogRef<DialogDateFiltersComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit(): void {
        let filters = JSON.parse(JSON.stringify(this.data.gridItem.setup.filters));
        if (_.isEmpty(filters)) {
            filters = this.filters;
        } else {
            this.filters = filters;
        }

        if (filters["allDays"]['checked']) {
            this.specificDaysDisabled = true;
            this.specificChecked = false;
        } else {
            this.specificDaysDisabled = false;
            this.specificChecked = true;
        }
    }

    onApplyClick(): void {
        this.dialogRef.close({ filters: this.filters });
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    radioButtonState(event): void {
        let day = event.source.id;
        this.filters[day]['checked'] = !this.filters[day]['checked'];
    }

    onTimeChange(value, period, day): void {
        if (value.split(":")[0] === "24") value = "24:00";

        if (period === "from") {
            let fromHours = value.split(":")[0];
            let fromMinutes = value.split(":")[1];
            let toHours = this.filters[day]["to"].split(":")[0];
            let toMinutes = this.filters[day]["to"].split(":")[1];

            if (+fromHours === +toHours && +fromMinutes > +toMinutes) {
                value = `${fromHours}:${toMinutes}`;
            }
        }

        if (period === "to") {
            let toHours = value.split(":")[0];
            let toMinutes = value.split(":")[1];
            let fromHours = this.filters[day]["from"].split(":")[0];
            let fromMinutes = this.filters[day]["from"].split(":")[1];

            if (toHours === fromHours && fromMinutes > toMinutes) {
                value = `${toHours}:${fromMinutes}`;
            }
        }

        this.filters[day][period] = value;
        if (day === "allDays") {
            let days = Object.keys(this.filters).filter(d => d !== "allDays");
            for (let i = 0; i < days.length; i++) {
                this.filters[days[i]][period] = value;
            }
        }
    }

    onAllClick(): void {
        this.specificDaysDisabled = true;
        let days = Object.keys(this.filters);
        for (let i = 0; i < days.length; i++) {
            this.filters[days[i]]['checked'] = true;
        }
    }

    onSpecificClick(): void {
        this.specificDaysDisabled = false;
        this.filters["allDays"]['checked'] = false;
    }
}
